import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Card from "../../components/Cards/Card";
import Slider from "@mui/material/Slider";
import KpiCard from "../../components/KPI/KpiCard";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useQlik } from "../../context/Qlik";

function DashboardDesktop({ app, config }) {
  const { container } = config.dashboard;
  const [vPeriodoSelecionado, setVPeriodoSelecionado] = useState("");
  const [selectPeriodo, setSelectPeriodo] = useState("");
  const [selectTipoSelecao, setSelectTipoSelecao] = useState("");
  const [vRanking2, setVRanking2] = useState(5);
  const { setSwitchOnDemand } = useQlik();

  const marks = [
    {
      value: 3,
      label: "3",
    },
    {
      value: 5,
      label: "5",
    },
    {
      value: 10,
      label: "10",
    },
    {
      value: 15,
      label: "15",
    },
    {
      value: 20,
      label: "20",
    },
    {
      value: 25,
      label: "25",
    },
  ];

  const handleSliderChangeCommitted = (event, newValue) => {
    const value = parseInt(newValue, 10);
    app.variable.setNumValue("vRanking2", value);
  };
  function updateSlider() {
    app.variable.getContent("vRanking2", (reply) => {
      const data = parseInt(reply.qContent.qString, 10);
      if (data !== undefined) {
        setVRanking2(data);
      }
    });
  }

  function valuetext(value) {
    return `${value}%`;
  }

  const initializeField = () => {
    app.variable.getContent("vPeriodoSelecionado", (reply) => {
      const data = reply.qContent.qString;
      setVPeriodoSelecionado(data);
    });
  };

  useEffect(() => {
    updateSlider();
    app.variable.getContent("vRanking2", (reply) => {
      const data = parseInt(reply.qContent.qString, 10);
      if (data !== undefined) {
        setVRanking2(data);
      }
    });

    if (app) {
      initializeField();
    }
  }, [app]);

  useEffect(() => {
    setSwitchOnDemand(false);
  });

  return (
    <div className="app dashboard">
      <div className="appContent">
        <LayoutCardsWrapper>
          {/* KPIs */}
          <div
            style={{ width: "100%", paddingInline: "10px", paddingTop: "8px" }}
          ></div>

          <CardWrapper customStyle={{ height: "15%", textAlign: "center" }}>
            {container[11].cards.map((card, index) => {
              return (
                <KpiCard
                  key={index}
                  app={app}
                  KPITitle={{
                    id: card.title.id,
                    hardTitle: card.title.hardTitle,
                  }}
                  percentageId={card.nativeObject.percentageId}
                  valueId={card.nativeObject.valueId}
                  customStyle={{ height: "100%" }}
                  isMobile={false}
                  selectedCheck={selectPeriodo}
                  tooltip={card.title.tooltip}
                ></KpiCard>
              );
            })}
          </CardWrapper>

          <CardWrapper
            customStyle={{
              paddingBottom: "0px",
              paddingRight: "0px",
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardWrapper
              customStyle={{
                paddingBottom: "0px",
                paddingRight: "0px",
                width: "100%",
                height: "20%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              {/* Lista-Medidas */}
              <Card
                header={{
                  tooltip: container[8].cards[4].title.tooltip,
                  hardTitle: container[8].cards[4].title.hardTitle,
                }}
                style={{ width: "67%" }}
              >
                <NativeObject
                  app={app}
                  key={{ id: container[8].cards[4].nativeObject.valueId }}
                  reference={{ id: container[8].cards[4].nativeObject.id }}
                  style={{
                    width: "100%",
                    height: "100%",
                    color: "4B81D0",
                    marginTop: "15px",
                  }}
                />
              </Card>

              {/* Slider */}
              <Card
                header={{
                  tooltip: container[8].cards[0].title.tooltip,
                  hardTitle: container[8].cards[0].title.hardTitle,
                }}
                style={{ width: "33%" }}
              >
                <Slider
                  aria-label="Always visible"
                  defaultValue={vRanking2}
                  getAriaValueText={valuetext}
                  onChangeCommitted={handleSliderChangeCommitted}
                  step={1}
                  max={25}
                  min={3}
                  marks={marks}
                  valueLabelDisplay="auto"
                  style={{ marginTop: "15px" }}
                />
              </Card>
            </CardWrapper>

            <CardWrapper
              customStyle={{
                paddingBottom: "0px",
                paddingRight: "0px",
                height: "90%",
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <CardWrapper
                customStyle={{
                  paddingBottom: "0px",
                  paddingRight: "0px",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {/* RANKING A */}
                <Card
                  header={{
                    tooltip: container[8].cards[1].title.tooltip,
                    hardTitle: `${container[8].cards[1].title.hardTitle} ${vPeriodoSelecionado}`,
                    hardSubtitle: container[8].cards[1].subtitle.hardSubtitle,
                  }}
                  expandable
                  exportTable
                  exportContainer
                  exportTableId={container[8].cards[1].nativeObject.id}
                  app={app}
                  style={{ width: "100%" }}
                >
                  <NativeObject
                    app={app}
                    key={{ id: container[8].cards[1].nativeObject.valueId }}
                    reference={{ id: container[8].cards[1].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: "4B81D0",
                    }}
                  />
                </Card>
              </CardWrapper>

              <CardWrapper
                customStyle={{
                  paddingBottom: "0px",
                  paddingRight: "0px",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {/* RANKING B */}
                <Card
                  header={{
                    tooltip: container[8].cards[2].title.tooltip,
                    hardTitle: `${container[8].cards[2].title.hardTitle} ${vPeriodoSelecionado}`,
                    hardSubtitle: container[8].cards[2].subtitle.hardSubtitle,
                  }}
                  expandable
                  exportTable
                  exportContainer
                  exportTableId={container[8].cards[2].nativeObject.id}
                  app={app}
                  style={{ width: "100%" }}
                >
                  <NativeObject
                    app={app}
                    key={{ id: container[8].cards[2].nativeObject.valueId }}
                    reference={{ id: container[8].cards[2].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: "4B81D0",
                    }}
                  />
                </Card>
              </CardWrapper>

              <CardWrapper
                customStyle={{
                  paddingBottom: "0px",
                  paddingRight: "0px",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {/* RANKING C */}
                <Card
                  header={{
                    tooltip: container[8].cards[3].title.tooltip,
                    hardTitle: `${container[8].cards[3].title.hardTitle} ${vPeriodoSelecionado}`,
                    hardSubtitle: container[8].cards[3].subtitle.hardSubtitle,
                  }}
                  expandable
                  exportTable
                  exportContainer
                  exportTableId={container[8].cards[3].nativeObject.id}
                  app={app}
                  style={{ width: "100%" }}
                >
                  <NativeObject
                    app={app}
                    key={{ id: container[8].cards[3].nativeObject.valueId }}
                    reference={{ id: container[8].cards[3].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: "4B81D0",
                    }}
                  />
                </Card>
              </CardWrapper>
            </CardWrapper>
          </CardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DashboardDesktop.defaultProps = {
  app: null,
  config: {},
};

DashboardDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DashboardDesktop;
